import { useNumericMenu, UseNumericMenuProps } from 'react-instantsearch';

import styles from './NumericMenu.module.scss';

export const NumericMenu = (props: UseNumericMenuProps) => {
  const { items, refine } = useNumericMenu(props);

  return (
    <ul className={styles.numericMenuList}>
      {items.map((item) => (
        <li key={item.label} className={styles.numericMenuItem}>
          <label className={styles.numericMenuLabel}>
            <input
              type="radio"
              checked={item.isRefined}
              onChange={() => refine(item.value)}
              className={styles.numericMenuRadio}
            />
            <span className={styles.numericMenuLabelText}>{item.label}</span>
          </label>
        </li>
      ))}
    </ul>
  );
};
